import React from 'react'
import styled from 'styled-components'
import ErrorBoundary from 'components/errorBoundary'
import { Typography, Avatar } from 'components'
import { Custom } from 'utils/displayResponsive'
import getImageUrl from 'utils/getImageUrl'
import CourseButton from './CourseButton'

const Container = styled.div`
  position: fixed;
  width: 100%;
  z-index: 1;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
  box-shadow: 0 -5px 10px 0 rgba(0, 0, 0, 0.1);
  padding: 12px 90px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 30px;

  @media (max-width: 1000px) {
    padding: 12px 40px;
  }
  @media (max-width: 720px) {
    padding: 12px 30px;
  }
  @media (max-width: 425px) {
    padding: 12px 20px;
  }
`
const DetailGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`
const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`
const PriceGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;

  @media (max-width: 640px) {
    width: 100%;
    display: grid;
    grid-template-columns: 35% 65%;
    gap: 0;
  }
`

const avatarSize = 58
const imageSize = avatarSize * 2

const Footer = (props) => {
  const { courseButtonProps, schoolName = '', schoolLogo, priceComponent } = props
  const { courseName = '' } = courseButtonProps
  return (
    <ErrorBoundary>
      <Container>
        <Custom minWidth={641}>
          <DetailGroup>
            <Avatar
              size={avatarSize}
              src={getImageUrl(
                schoolLogo,
                `https://via.placeholder.com/${imageSize}`,
                imageSize,
                imageSize
              )}
            />
            <TextGroup>
              <Typography color="primary1" fontSize="text-xl" fontWeight={600} numberOfLines={1}>
                {courseName}
              </Typography>
              <Typography color="gray6" numberOfLines={1}>
                {schoolName}
              </Typography>
            </TextGroup>
          </DetailGroup>
        </Custom>
        <PriceGroup>
          {priceComponent}
          <CourseButton {...courseButtonProps} isFooter={true} />
        </PriceGroup>
      </Container>
    </ErrorBoundary>
  )
}

export default Footer
